<template>
    <div class="privacy-policy-component">
        <h1>Accept & Proceed</h1>
        <p>In order to continue through the website you must confirm your acceptance to both the Privacy Policy and the Corporate Policy documents. Accepting the policies at this stage does not tie you into anything it just allows you to move through the process and view the information available to you.</p>

        <div class="card">
            <h2>Privacy Policy</h2>


            <div class="triangle"></div>

        </div>

        <div class="agree">
            <input type="checkbox" name="confirm" id="confirm" class="confirm" @change="privacyPolicy($event)" @value="$parent.$parent.policies.privacyPolicyConfirmed">
            <label for="confirm">I confirm that I have read and accept the privacy policy</label>
        </div>
    </div>
</template>

<script>

    import { EventBus } from '../event-bus.js';

    export default {

        methods: {

            privacyPolicy(value) {

                const checked = value.target.checked;
                EventBus.$emit('privacyPolicyConfirmed', checked);

            }

        },

        components: {
            EventBus
        }


    }
</script>
